import {BrowserRouter as Router , Routes, Route} from "react-router-dom";
import Home from './pages/home/Home';
import WorkProjects from './pages/workProject/WorkProject';
import Designs from './pages/designs/Designs';
import WorkStations from "./pages/workstation/WorkStations";

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/workstation' element={<WorkStations />}></Route>
        <Route path='/projects' element={<WorkProjects />}></Route>
        <Route path='/designs' element={<Designs />}></Route>
      </Routes>
    </Router>
  );
}

export default App;